var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountryKr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 25.5H3V6H29V25.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4267 15.7652C16.4267 18.1304 14.5072 20.0499 12.142 20.0499C9.7769 20.0499 7.85737 18.1304 7.85737 15.7652C7.85737 13.4001 9.7769 11.4806 12.142 11.4806C14.5072 11.4806 16.4267 13.3963 16.4267 15.7652Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8006 16.0166C21.8006 19.1016 19.325 21.6076 16.2667 21.6076C13.2084 21.6076 10.7367 19.1016 10.7367 16.0166C10.7367 12.9316 13.2122 10.4218 16.2705 10.4218C19.3288 10.4218 21.8006 12.9316 21.8006 16.0166Z",
    fill: "#C70000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95141 10.8293L8.13539 7.14639L8.8933 7.79766L5.70551 11.4844L4.95141 10.8293ZM5.99496 11.7319L9.17895 8.04903L9.93686 8.69649L6.74907 12.387L5.99496 11.7319Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95141 10.8293L8.13539 7.14639L8.8933 7.79766L5.70551 11.4844L4.95141 10.8293Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95141 10.8293L8.13539 7.14639L8.8933 7.79766L5.70551 11.4844L4.95141 10.8293ZM7.06137 12.6574L10.2454 8.9669L11.0033 9.62198L7.81547 13.3087L7.06137 12.6574Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95141 10.8293L8.13539 7.14639L8.8933 7.79766L5.70551 11.4844L4.95141 10.8293Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95141 10.8293L8.13539 7.14639L8.8933 7.79766L5.70551 11.4844L4.95141 10.8293ZM24.3295 7.14258L27.4907 10.8521L26.7289 11.4996L23.5678 7.79004L24.3295 7.14258ZM22.2081 8.95166L25.3693 12.6612L24.6076 13.3087L21.4464 9.59912L22.2081 8.95166Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7375 11.0883L25.7235 8.50604L26.2833 9.1535L23.0841 12.0252L22.7299 11.0883H22.7375Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4166 20.1832L23.3545 23.8318L22.6042 23.2072L25.6663 19.5586L26.4166 20.1832ZM23.2784 8.0376L26.4395 11.7472L25.6816 12.3946L22.5243 8.68125L23.2784 8.0376ZM27.4564 21.0478L24.3905 24.6964L23.6364 24.0718L26.7023 20.4231L27.4564 21.0478ZM25.3579 19.3034L22.2957 22.9521L21.5455 22.3274L24.6076 18.6788L25.3579 19.3034Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8166 15.0302C10.9918 16.4394 11.247 18.0085 13.4141 18.1685C14.2253 18.218 15.8059 17.978 16.3467 15.7614C17.0627 13.6362 19.2032 13.0269 20.6619 14.177C21.4959 14.7179 21.7245 15.5748 21.7778 16.2223C21.713 18.2789 20.5247 20.0689 19.0051 20.8687C17.2532 21.9085 14.8309 21.9313 12.7095 20.3546C11.7536 19.4596 10.4167 17.8028 10.8166 15.0302Z",
    fill: "#3D5897"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4383 20.1299L26.4319 22.7045L25.8758 23.352L22.5585 20.6174L23.4345 20.1299H23.4383Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76049 19.6195L9.92163 23.3253L9.15991 23.9728L5.99877 20.267L6.76049 19.6195Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21586 22.6702L9.20942 20.0842L9.76928 20.7316L6.57006 23.6071L6.21586 22.6664V22.6702Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81166 18.7245L10.9728 22.4303L10.2111 23.0777L7.04994 19.372L7.81166 18.7245ZM5.69028 20.5336L8.85141 24.2394L8.08969 24.8868L4.92856 21.1811L5.69028 20.5336Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#D7D7D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryKr);
export default __webpack_public_path__ + "static/media/country-kr.86b6f4bf.svg";
export { ForwardRef as ReactComponent };